const PrivacyPolicyPage = () => {
  return (
    <div className="container py-5">
      <h1 className="mb-4">Politika zasebnosti</h1>

      <p>
        Bazarc se zavezuje k varovanju vaše zasebnosti. Vaše osebne podatke uporabljamo
        izključno za zagotavljanje storitev in komunikacijo z vami.
      </p>

      <h3 className="mt-4 mb-3">Katere podatke zbiramo?</h3>
      <p>
        Zbiramo podatke, ki nam jih posredujete ob registraciji (ime, e-naslov ipd.)
        ter podatke o vaših objavah in komunikaciji na platformi.
      </p>

      <h3 className="mt-4 mb-3">Varovanje podatkov</h3>
      <p>
        Vaši podatki so shranjeni na varovanih strežnikih in niso posredovani tretjim osebam
        brez vašega soglasja, razen v primeru zakonskih obveznosti.
      </p>

      <h3 className="mt-4 mb-3">Piškotki</h3>
      <p>
        Za delovanje spletne strani uporabljamo osnovne piškotke, več o tem v <strong>Politiki piškotkov</strong>.
      </p>
    </div>
  );
};

export default PrivacyPolicyPage;